import { defineRecipe } from '@chakra-ui/react';

// The portal never themed Input — in v2 it inherited Chakra's default, whose
// focus state was blue.500 (border + ring). v3's stock input defaults to the
// `outline` variant, which draws its focus ring from colorPalette.focusRing;
// with no colorPalette set that resolves through gray and reads as black.
// Restores that focus colour, plus the v2 size below.
const inputRecipe = defineRecipe({
  base: {
    '--focus-color': 'colors.primary.500',
    _focusVisible: {
      borderColor: 'primary.500',
    },
    // v2's outline variant emitted _invalid before _focusVisible at equal
    // specificity, so a focused invalid field turned blue. Stock v3's _invalid
    // also points the focus ring at the error colour, which kept it red
    // (DEV-2044). The merge keeps _invalid at its stock position, ahead of the
    // focus-visible rule, so only the ring colour needs pointing back.
    _invalid: {
      focusRingColor: 'var(--focus-color)',
    },
  },
  variants: {
    variant: {
      // v2 also drew a 1px ring outside an unfocused invalid field's red
      // border (box-shadow 0 0 0 1px red.500); stock v3 draws the border only.
      // An outline rather than a box-shadow, so the focus ring replaces it as
      // v2's focus box-shadow did.
      outline: {
        _invalid: { outline: '1px solid var(--error-color)' },
      },
    },
    size: {
      // v2: fontSize md (16px), px 4. v3: textStyle sm (14px), px 3. Override
      // the whole textStyle — a bare fontSize ties with stock's at equal
      // specificity. textStyle md also brings lineHeight 1.5rem, which v2 never
      // set, hence the explicit `normal`. Radius: v2 md (6px), v3 l2 (4px).
      md: {
        textStyle: 'md',
        lineHeight: 'normal',
        px: '4',
        borderRadius: 'md',
      },
    },
  },
});

export default inputRecipe;
